import { render, staticRenderFns } from "./tags-sort.vue?vue&type=template&id=c9d03bf6&scoped=true&"
import script from "./tags-sort.vue?vue&type=script&lang=js&"
export * from "./tags-sort.vue?vue&type=script&lang=js&"
import style0 from "./tags-sort.vue?vue&type=style&index=0&id=c9d03bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d03bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/www/xmg-cms-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c9d03bf6', component.options)
    } else {
      api.reload('c9d03bf6', component.options)
    }
    module.hot.accept("./tags-sort.vue?vue&type=template&id=c9d03bf6&scoped=true&", function () {
      api.rerender('c9d03bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cat-base/tags-sort.vue"
export default component.exports